import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';

module.exports = React.createClass({
    mixins: [LinkedStateMixin],
    getInitialState: function() {
        return {
            searchString: ''
        };
    },
    handleOnSelected: function(e) {
        if (this.props.multiSelect) {
            var listItem = $(e.target).closest('.hc-list-view-item')[0];
            var id = listItem.getAttribute('data-key');
            var item = HC_GetItemById(this.props.data, id);

            var newCheckedArray = $.extend({}, this.props.checkedItems);
            newCheckedArray[id] = !this.props.checkedItems[id];
            if (this.props.checkChanged)
                this.props.checkChanged(newCheckedArray);
            return;
        }
        if (this.props.onSelect) {
            var i = $(e.target).closest(".hc-list-view-item").attr('data-key');
            this.props.onSelect(i);
        }
    },
    componentDidUpdate: function() {
        var items = $(this.refs['list']).children(".hc-list-view-item");
        if (this.props.multiSelect) {
            HC_SelectItem(items, null, 'hc-list-active-item');
        } else {
            var selected = this.props.selectedId != null ? items.filter("[data-key='" + this.props.selectedId + "']").first() : null;
            HC_SelectItem(items, selected, 'hc-list-active-item');
        }
        HC_SubscribeHammerEvent(this.refs.list, "swiperight", HC_ToggleNavPanel);
    },
    componentWillUnmount: function() {
        HC_UnsubscribeHammerEvent(this.refs.list, "swiperight");
    },
    searchChanged: function(e) {
        this.state.searchString = e.target.value;
        this.setState({searchString: e.target.value});
        if (HC_DeviceType() === HC_CONST.SCR_DESCKTOP || !this.props.order) {
            var items = this.getFilteredItems();
            if (items.length > 0 && items[0].id != this.props.selectedId)
                this.props.onSelect(items[0].id);
        }
    },
    setOrderUp: function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.props.onSetOrderUp) {
            var id = e.target.getAttribute('data-key');
            this.props.onSetOrderUp(id);
        }
    },
    setOrderDown: function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.props.onSetOrderDown) {
            var id = e.target.getAttribute('data-key');
            this.props.onSetOrderDown(id);
        }
    },
    getFilteredItems: function() {
        const {data, getSearchString, getCaption} = this.props;
        const searchMethod = getSearchString || getCaption;
        const items = data || [];
        if (this.state.searchString) {
            const searchString = this.state.searchString.toLowerCase();
            return items.filter(o => searchMethod(o).toLowerCase().indexOf(searchString) >= 0);
        }
        return items;
    },

    renderChecklistButtons(o) {
        if (o.id == -1)
            return null; // no buttons for new checklist

        if (o.manual_state == 1) {
            // only launch button for inactive manual checklist
            return (
                <div style={{marginTop:'5px', marginBottom:'5px'}}>
                    <button className="form-control hc-button" data-key={o.id} onClick={this.props.onLaunch}>{HC_LANG.CHL_LAUNCH_CHECKLIST}</button>
                </div>
            );
        }

        if (o.manual_state == 2) {
            // launched
            return (
                <div style={{marginTop:'5px', marginBottom:'5px'}}>
                    <button className="form-control hc-button" style={{marginRight:'10px', backgroundColor:'white', borderColor:'#30ae97', boxShadow:'none', borderStyle:'solid', borderWidth:'1px'}}>
                        <i className="fa hc-fa-small fa-clock-o" style={{color:'#30ae97 !important', marginRight:'7px', fontSize: '0.8rem !important'}}/>
                        <span style={{color:'#30ae97 !important', display:'inline-block'}}>{HC_LANG.CHL_LAUNCHED}</span>
                    </button>
                    <button className="form-control hc-button" data-key={o.id} onClick={this.props.onCancelLaunch}>{HC_LANG.CHL_CANCEL_LAUNCH}</button>
                </div>
            );
        }

        return null;
    },
    render: function() {
        var items = this.props.data;
        if (items === null || items === undefined) {
            items = [];
        }
        var devType = HC_DeviceType();
        var searchEnabled = (devType === HC_CONST.SCR_DESCKTOP || !this.props.order) &&
            !this.props.multiSelect && items.length > 0 && items[0].id != -1;

        if (searchEnabled && this.state.searchString) {
            items = this.getFilteredItems();
        }
        if (!searchEnabled && this.state.searchString) {
            this.setState({searchString: null});
        }
        var i = 0;

        var favorite;
        var listItems = items.map(function(o) {
            var itemCaption = this.props.getCaption(o);
            var itemText = this.props.getText(o);
            let checkbox, orderPanel;
            if (this.props.multiSelect) {
                checkbox = (<input className="big-checkbox"
                                   checked={this.props.checkedItems[o.id] === true} type="checkbox"
                                   style={{marginTop:'5px', marginRight:"5%", flex: '0 0 20px', WebkitFlex: '0 0 20px', verticalAlign:'top'}}/>);
            }
            var orderClass = "";
            if (this.props.order) {
                var up, down;
                if (i > 0 && o.id != -1) {
                    up = (
                        <div className="hc-hover" key="1" data-key={o.id} onClick={this.setOrderUp} style={{cursor:'pointer'}}>
                            <i data-key={o.id} className="fa hc-fa-medium2 hc-fa-action fa-angle-up"  style={{position:'absolute', top:'-10px', right:'-15px', padding:'10px', paddingRight:'20px'}}></i>
                        </div>
                    );
                }
                if (i < items.length-1  && o.id != -1) {
                    down = (
                        <div className="hc-hover" key="2" data-key={o.id} onClick={this.setOrderDown} style={{cursor:'pointer'}}>
                            <i data-key={o.id} className="fa hc-fa-medium2 hc-fa-action fa-angle-down" style={{position:'absolute', bottom:'-13px', right:'-15px', padding:'8px', paddingRight:'20px'}}></i>
                        </div>
                    );
                }

                orderPanel = (
                    <div className="hc-order-panel" style={{flex: '0 0 20px', WebkitFlex: '0 0 20px', position:'relative', minHeight:'100px'}}>
                        {up}
                        {down}
                    </div>
                );
                orderClass = " hc-list-order-item";
            }



            var launchButtons;
            if (this.props.launch) {
                launchButtons =this.renderChecklistButtons(o);
            }

            let mainStyle = {padding: "15px", paddingTop:"3%", display:'flex', cursor:"pointer"};
             if (favorite == undefined)
                 mainStyle.paddingLeft = "10%";

            ++i;
            return (
                <div data-key={o.id} key={o.id} className={"hc-list-view-item hc-flex-display hc-div-order" + orderClass}
                     style={mainStyle}
                     onClick={this.handleOnSelected}>
                    {favorite}
                    {checkbox}
                    <div style={{flex: '1 1 auto', WebkitFlex: '1 1 auto', marginRight:'20px'}}>
                        <div className="hc-f2" style={{paddingBottom:"5px", wordBreak: 'break-all'}}>{itemCaption}</div>
                        <div className="hc-f4 hc-f-l">
                            {itemText}
                        </div>
                        {launchButtons}
                    </div>
                    {orderPanel}
                </div>);
        }.bind(this));

        var searchPanel;
        if (searchEnabled) {
            searchPanel = (<div className="hc-bb" style={{height: "68px", position:'relative'}}>
                <input className="hc-f4" ref="search" type="text" placeholder={HC_LANG.CHL_SEARCH}
                       value={this.state.searchString} onChange={this.searchChanged} spellCheck="false"
                       autoComplete="off"
                       style={{position:'absolute', width:'95%', left:'1px', height:'100%', border:'none', outline:'none', paddingLeft:'2rem', paddingRight:'3rem'}}/>
                <i className="fa fa-search" onClick={function(){this.refs.search.focus()}.bind(this)} style={{position:'absolute', fontSize:'1.6rem', color:'#bfc7cd', cursor:"pointer", right:'1rem', top:'18px'}}/>
            </div>)
        }

        return (
            <div>
                {searchPanel}
                <div ref="list" className="hc-list-view" style={{position: "absolute", overflowY: "auto", WebkitOverflowScrolling:'touch', top: searchPanel ? "128px" : "68px"/*toppanel width*/, bottom: 0, width:"100%"}}>
                    {this.props.isEmpty ?
                        <div className="hc-f-l hc-f4" style={{textAlign: "center", marginTop:"20px"}}>{HC_LANG.CHL_LIST_EMPTY}</div> :
                        listItems}
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./checklists/checklistview.js